import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { CheckCircle, Euro, Clock, FileText, Calculator, Phone } from 'lucide-react';

const Tariffe = () => {
  const servizi = [
    {
      nome: "Fisioterapia",
      prezzo: "€ 50",
      durata: "45-60 minuti",
      descrizione: "Seduta individuale di fisioterapia con valutazione e trattamento personalizzato"
    },
    {
      nome: "Riabilitazione Motoria",
      prezzo: "€ 60",
      durata: "60 minuti",
      descrizione: "Programma completo di riabilitazione motoria post-traumatica o post-chirurgica"
    },
    {
      nome: "Ginnastica Posturale",
      prezzo: "€ 35-50",
      durata: "45 minuti",
      descrizione: "Seduta individuale di rieducazione posturale e correzione degli squilibri"
    },
    {
      nome: "Terapia Neuropsicomotoria (TNPEE)",
      prezzo: "€ 50-70",
      durata: "45-60 minuti",
      descrizione: "Trattamento specializzato per bambini e adolescenti con disturbi neuromotori"
    },
    {
      nome: "Trattamento Plagiocefalie",
      prezzo: "€ 60-80",
      durata: "45-60 minuti",
      descrizione: "Trattamento specializzato per deformità craniche posizionali e brachicefalie"
    },
    {
      nome: "Torcicollo Miogeno Congenito",
      prezzo: "€ 60-80",
      durata: "45-60 minuti",
      descrizione: "Terapia manuale e stretching specifico per torcicollo miogeno"
    },
    {
      nome: "Paralisi Ostetriche",
      prezzo: "€ 80-100",
      durata: "60-90 minuti",
      descrizione: "Riabilitazione specializzata per lesioni del plesso brachiale neonatale"
    },
    {
      nome: "Disturbi Motori Neonatali",
      prezzo: "€ 70-90",
      durata: "60 minuti",
      descrizione: "Valutazione e trattamento precoce dei disturbi dello sviluppo motorio"
    },
    {
      nome: "Riabilitazione Post-Chirurgica",
      prezzo: "€ 45-65",
      durata: "60 minuti",
      descrizione: "Percorso riabilitativo specifico per il recupero post-operatorio"
    },
    {
      nome: "Terapia Manuale",
      prezzo: "€ 55",
      durata: "45 minuti",
      descrizione: "Tecniche manuali specializzate per problematiche muscolo-scheletriche"
    },
    {
      nome: "Pacchetto 5 Sedute",
      prezzo: "€ 200-250",
      durata: "Variabile",
      descrizione: "Pacchetto conveniente per cicli di trattamento (sconto 10-15%)"
    },
    {
      nome: "Pacchetto 10 Sedute",
      prezzo: "€ 400-480",
      durata: "Variabile",
      descrizione: "Pacchetto per trattamenti prolungati (sconto 15-20%)"
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-12">
            <Badge className="bg-primary/10 text-primary border-primary/20">
              Tariffe
            </Badge>
            <h1 className="text-4xl lg:text-5xl font-bold">I Nostri Prezzi</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Tariffe trasparenti e competitive per trattamenti di alta qualità. 
              Tutti i nostri servizi sono detraibili fiscalmente al 19%.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <Card className="medical-card text-center">
              <CardHeader>
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Euro className="h-8 w-8 text-primary" />
                </div>
                <CardTitle>Prezzi Trasparenti</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">Nessun costo nascosto, tariffe chiare e competitive</p>
              </CardContent>
            </Card>

            <Card className="medical-card text-center">
              <CardHeader>
                <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FileText className="h-8 w-8 text-secondary" />
                </div>
                <CardTitle>Detraibilità Fiscale</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">Tutti i trattamenti sono detraibili al 19% nella dichiarazione dei redditi</p>
              </CardContent>
            </Card>

            <Card className="medical-card text-center">
              <CardHeader>
                <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Calculator className="h-8 w-8 text-accent" />
                </div>
                <CardTitle>Pacchetti Convenienti</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">Sconti fino al 20% con i nostri pacchetti multi-seduta</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Listino Prezzi */}
      <section className="section-padding bg-muted/30">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-16">
            <Badge className="bg-primary/10 text-primary border-primary/20">
              Listino Prezzi
            </Badge>
            <h2 className="text-4xl font-bold">I Nostri Servizi</h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Tariffe competitive per trattamenti di alta qualità
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {servizi.map((servizio, index) => (
              <Card key={index} className="medical-card hover:scale-105 smooth-transition">
                <CardHeader>
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <CardTitle className="text-lg mb-2">{servizio.nome}</CardTitle>
                      <div className="flex items-center space-x-2 text-sm text-muted-foreground mb-2">
                        <Clock className="h-4 w-4" />
                        <span>{servizio.durata}</span>
                      </div>
                    </div>
                    <Badge variant="secondary" className="text-lg font-bold">
                      {servizio.prezzo}
                    </Badge>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground mb-4">{servizio.descrizione}</p>
                  <div className="flex items-center space-x-2 text-xs text-green-600">
                    <CheckCircle className="h-3 w-3" />
                    <span>Detraibile fiscalmente</span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Detraibilità Fiscale */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <Card className="medical-card">
              <CardHeader className="text-center">
                <CardTitle className="text-2xl">Detraibilità Fiscale</CardTitle>
                <CardDescription>
                  Tutti i nostri trattamenti sono detraibili fiscalmente
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="text-lg font-semibold mb-4">Come Funziona</h3>
                    <ul className="space-y-2">
                      <li className="flex items-start space-x-2">
                        <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                        <span className="text-sm">Detrazione del 19% nella dichiarazione dei redditi</span>
                      </li>
                      <li className="flex items-start space-x-2">
                        <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                        <span className="text-sm">Ricevuta fiscale rilasciata per ogni seduta</span>
                      </li>
                      <li className="flex items-start space-x-2">
                        <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                        <span className="text-sm">Valido per tutti i trattamenti fisioterapici</span>
                      </li>
                    </ul>
                  </div>
                  
                  <div className="bg-primary/5 p-6 rounded-lg">
                    <h4 className="font-semibold mb-2">Esempio di Calcolo</h4>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span>Spesa annuale:</span>
                        <span className="font-semibold">€ 500</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Detrazione 19%:</span>
                        <span className="font-semibold text-green-600">€ 95</span>
                      </div>
                      <div className="border-t pt-2 flex justify-between font-semibold">
                        <span>Costo effettivo:</span>
                        <span>€ 405</span>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Metodi di Pagamento */}
      <section className="section-padding bg-slate-50 dark:bg-slate-900">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Metodi di Pagamento</h2>
            <p className="text-lg text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
              Accettiamo diverse modalità di pagamento per la tua comodità
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Immagine Metodi di Pagamento */}
            <div className="text-center">
              <img 
                src="/images/IMG_3563.jpeg" 
                alt="Metodi di pagamento accettati: VISA, Mastercard, American Express, Maestro, Discover, JCB, UnionPay" 
                className="max-w-full h-auto mx-auto rounded-lg shadow-lg"
              />
              <p className="text-sm text-slate-500 dark:text-slate-400 mt-4">
                Pagamenti sicuri e protetti
              </p>
            </div>

            {/* Lista Metodi */}
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold mb-4 flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  Carte di Credito e Debito
                </h3>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>VISA</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>Mastercard</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>American Express</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>Maestro</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>VISA Electron</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>Discover</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>JCB</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>UnionPay</span>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-semibold mb-4 flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  Altre Modalità
                </h3>
                <div className="space-y-2 text-sm">
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>Contanti</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>Bonifico Bancario</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span>POS in sede</span>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg">
                <h4 className="font-semibold text-blue-800 dark:text-blue-200 mb-2">Sicurezza Garantita</h4>
                <p className="text-sm text-blue-700 dark:text-blue-300">
                  Tutti i pagamenti con carta sono protetti da crittografia PCI DSS e processati tramite SumUp, 
                  garantendo la massima sicurezza delle tue transazioni.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding medical-gradient text-white">
        <div className="container-custom text-center space-y-8">
          <h2 className="text-4xl font-bold">Prenota la Tua Visita</h2>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">
            Contattaci per un preventivo personalizzato e inizia il tuo percorso di riabilitazione
          </p>
          <Button size="lg" variant="secondary" className="bg-white text-primary hover:bg-white/90">
            <Phone className="mr-2 h-4 w-4" />
            Chiama: +39 347 5391433
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Tariffe;